import * as React from 'react';
import useProductName from 'brand-customization/useProductName';

const GroupSearchPattern = () => {
  const productName = useProductName();

  return (
    <span>
      The search pattern used to find groups in LDAP for mapping to {productName} teams, e.g{' '}
      <code className="text-nowrap" key="group-search-pattern-example-1">
        (objectClass=group)
      </code>
    </span>
  );
};

const TeamNameAttribute = () => {
  const productName = useProductName();

  return (
    <span>
      Which LDAP attribute to use for the full name of the {productName} team, usually{' '}
      <code key="team-name-attribute-example">cn</code>.
    </span>
  );
};

const TeamUniqueIdAttribute = () => {
  const productName = useProductName();

  return (
    <span>
      Which LDAP attribute to use for the uniq ID attribute of the {productName} team, e.g.{' '}
      <code key="team-unique-id-attribute">entryUUID</code>.
    </span>
  );
};

const help = {
  groupSearchBase: (
    <span>
      The base tree to limit the LDAP group search query to, e.g.{' '}
      <code key="group-search-base-example">ou=people,dc=example,dc=com</code>.
    </span>
  ),
  groupSearchPattern: <GroupSearchPattern />,
  teamUniqueIdAttribute: <TeamUniqueIdAttribute />,
  teamNameAttribute: <TeamNameAttribute />,
  teamDefaultRoles: 'The default roles synchronized teams will obtain. All users of a team will inherit these roles.',
};

const initialValues = {
  teamUniqueIdAttribute: 'entryUUID',
  teamNameAttribute: 'cn',
};

export default { help, initialValues };
